import React from "react";
import Footer from "../../Footer/Footer";
import "./Home.css";
import About from "../About/About";
import Banner from "../Banner/Banner";
import Services from "../Services/Services";
import Skill from "../../Skill/Skill";
import ContactForm from "../Contact/ContactForm";
import Projects from "../../Projects/Projects";
const Home = () => {

  return (
    <div
      className="banner"
      style={{
        backgroundColor: "#02022962",
        color: "white",
        overflow: "hidden",
      }}
    >
      <Banner />
      <About />
      <Skill />
      <Projects />
      <Services />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
